import { useEffect, useRef } from 'react'
import toast from 'react-hot-toast'
import { notificationService } from '@/services/firebase/notifications'
import { useAuthStore } from '@/store/authStore'

/**
 * Registers FCM push notification token for the current engineer and
 * sets up a foreground message listener.
 * Should be mounted once inside a protected route (e.g. MainLayout).
 */
export const usePushNotifications = () => {
  const { user } = useAuthStore()
  const registeredFor = useRef<string | null>(null)

  useEffect(() => {
    if (!user || user.role !== 'engineer') return
    if (registeredFor.current === user.uid) return
    if (!('Notification' in window) || !('serviceWorker' in navigator)) return

    registeredFor.current = user.uid

    notificationService.registerToken(user.uid).then(token => {
      if (token) {
        console.info('[FCM] Push token registered for', user.uid)
      }
    })
  }, [user])

  useEffect(() => {
    if (!user || user.role !== 'engineer') return

    const unsub = notificationService.onForegroundMessage(payload => {
      toast(`${payload.title} — ${payload.body}`, {
        duration: 6000,
        icon: '📋',
        style: {
          maxWidth: '340px',
          fontSize: '13px',
          background: '#0d2040',
          color: '#e0eaff',
          borderLeft: '4px solid #3b82f6',
        },
      })
    })

    return () => unsub()
  }, [user])
}
